import * as ReactRouter from "react-router";
import { connect } from "react-redux";
import Component from "./View";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as actions from "../actions";
import * as selectors from "../selectors";
const mapStateToProps = (state: RootState) => ({
  isBusinessAccount: selectors.getIsBusinessAccount(state),
  uenLabel: selectors.getUenLabel(state),
  newEscalationsCommentsCount: selectors.getNewEscalationsCommentsCount(state)
});

const mapDispatchToProps = {
  toast: actions.toast
};

// Fixed template
export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  ReactRouter.RouteProps;

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false
})(Component);
